import { TransactionActionTypes, transactionInitialState } from './transaction.model';

const reducer = (state = transactionInitialState, action) => {
    switch (action.type) {
        case TransactionActionTypes.FETCH_TRANSACTION_REQUEST:
        case TransactionActionTypes.FETCH_PRICES_REQUEST:
        case TransactionActionTypes.CREATE_ORDER_REQUEST:
        case TransactionActionTypes.TRANSFER_COINS_REQUEST:
            return {
                ...state,
                isLoading: true,
            };

        case TransactionActionTypes.FETCH_TRANSACTION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                transactions: action.payload
            };

        case TransactionActionTypes.FETCH_PRICES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                prices: action.payload
            };

        case TransactionActionTypes.CREATE_ORDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                orders: [action.payload, ...state.orders]
            };

        case TransactionActionTypes.FETCH_TRANSACTION_FAILURE:
        case TransactionActionTypes.CREATE_ORDER_FAILURE:
        case TransactionActionTypes.FETCH_PRICES_FAILURE:
        case TransactionActionTypes.TRANSFER_COINS_FAILURE:
            return {
                ...state,
                isLoading: false
            };

        default:
            return state;
    }
}

export { reducer as TransactionReducer };